import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 4px;
  padding: 8px 16px;
  position: relative;

  + div{
    margin-top: 8px;
  }

  .rotate{
    margin-left: 4px;
    font-size: 18px;
    transform: rotate(10deg);
  }
`;

export const WrapperMenu = styled.div`
  position: absolute;
  top: 16px;
  right: 12px;
`;